import { render, staticRenderFns } from "./BodyCompositionsMeasurements.vue?vue&type=template&id=f2b415be&scoped=true"
import script from "./BodyCompositionsMeasurements.vue?vue&type=script&lang=js"
export * from "./BodyCompositionsMeasurements.vue?vue&type=script&lang=js"
import style0 from "./BodyCompositionsMeasurements.vue?vue&type=style&index=0&id=f2b415be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b415be",
  null
  
)

export default component.exports